
const ToggleMenuIcon = ({ className = "", onClick, size = 24, color = "white" }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
    >
      {/* Linea superiore */}
      <rect
        x="3"
        y="6"
        width="18"
        height="2"
        rx="1"
        fill={color}
      />
      {/* Linea centrale */}
      <rect
        x="3"
        y="11"
        width="18"
        height="2"
        rx="1"
        fill={color}
      />
      {/* Linea inferiore */}
      <rect
        x="3"
        y="16"
        width="18"
        height="2"
        rx="1"
        fill={color}
      />
    </svg>
  );
};

export default ToggleMenuIcon;
